import DashPattern from "../../../../assets/other/dashPattern.png";
import CrosswalkPattern from "../../../../assets/other/crosswalkPattern.png";
import BikeLanePattern from "../../../../assets/other/bikeLanePattern.png";
import BlackPattern from "../../../../assets/other/blackPattern.png";
import YellowStripePattern from "../../../../assets/other/yellowStripePattern.png";

import IdeaPinYellow from "../../../../assets/other/IdeaPinYellow.png";
import IdeaPinGrey from "../../../../assets/other/IdeaPinGrey.png";

import roundGreenMarker from "../../../../assets/markers/roundGreenMarker.png";

const images = [
  { url: YellowStripePattern, id: "YellowStripePattern" },
  { url: DashPattern, id: "DashPattern" },
  { url: CrosswalkPattern, id: "CrosswalkPattern" },
  { url: BikeLanePattern, id: "bikeLanePattern" },
  { url: BlackPattern, id: "BlackPattern" },
  { url: IdeaPinYellow, id: "IdeaPinYellow" },
  { url: IdeaPinGrey, id: "IdeaPinGrey" },
  { url: roundGreenMarker, id: "roundGreenMarker" },
];

export function addImagesToMap(map) {
  return Promise.all(
    images.map(
      (img) =>
        new Promise((resolve, reject) => {
          map.loadImage(img.url, (error, image) => {
            if (error) reject(error);
            map.addImage(img.id, image);
            resolve();
          });
        })
    )
  );
}
